














































import { Component, Vue } from "vue-property-decorator";
import MyMap from "@/components/MyMap.vue";
import MobileNav from "@/components/MobileNav.vue";
import MediaFeed from "@/components/MediaFeed.vue";
import BaseLoading from "@/components/BaseLoading.vue";
import Search from "@/components/Search.vue";
import { Image, Location, FeedImage, Direction } from "@/util/types";
import { getImage } from "@/util/mockImages";
import { LngLatBounds } from "mapbox-gl";
import Geohash from "ngeohash";
import { app } from "@/firebase/app";
import { db, PHOTO_COUNT_PATH, PHOTOS_PATH } from "@/firebase/db";
import { QueryDocumentSnapshot } from "@firebase/firestore-types";
import { CloudFunctionApis } from "@/services/cloudFunctionApis";
import { Debounce } from "vue-debounce-decorator";
import MobilePage from "@/components/MobilePage.vue";
import ImageUpload from "@/components/ImageUpload.vue";

@Component({
  components: {
    MobilePage,
    MyMap,
    MobileNav,
    MediaFeed,
    BaseLoading,
    Search,
    ImageUpload
  }
})
export default class Home extends Vue {
  isLoading: boolean = false;
  hasResults: boolean = true;
  perPage: number = 10;
  headerHeight: number = 200;
  footerHeight: number = 45;
  markerLocation: Location | null = null;
  api = new CloudFunctionApis();
  mapBounds: LngLatBounds;
  stagedMapBounds: LngLatBounds;
  currentPage = 1;
  isRedoSearchButtonVisible: boolean = false;
  firstMapLoad: boolean = true;

  feedImages: Array<FeedImage> = [];
  geohashesByLevel: { [key: number]: Array<string> } = {};
  // This is a growing cache
  photoCountsByGeohash: { [key: string]: QueryDocumentSnapshot | null } = {};
  // Keep track of the current geohashes that have photo count documents
  currentPhotoCountGeohashes: Array<string> = [];

  mediaFeedStyles: string = `
    margin-top:${this.headerHeight}px;
    margin-bottom:${this.footerHeight}px;
  `;
  searchQuery: string = "";
  imageUploaderIsOpen: Boolean = false;

  constructor(props: any) {
    super(props);
    const startingBounds = new LngLatBounds(
      { lng: -120, lat: -50 },
      { lng: 120, lat: 50 }
    );
    this.mapBounds = startingBounds;
    this.stagedMapBounds = startingBounds;
    this.isLoading = true;
  }

  mounted() {
    this.loadImages();
  }

  async loadImages() {
    this.isLoading = true;
    this.hasResults = true;

    const response = await this.api.getPopularPhotos(
      this.mapBounds,
      this.currentPage,
      this.searchQuery
    );
    const images = response.data.data as Array<FeedImage>;
    this.isLoading = false;

    if (images.length <= 0 && this.feedImages.length <= 0) {
      this.hasResults = false;
      return;
    }
    this.feedImages.push(...images);
  }

  // getHashesInBounds(bounds: LngLatBounds, level: number) {
  //   return Geohash.bboxes(
  //     bounds.getSouthWest().lat,
  //     bounds.getSouthWest().lng,
  //     bounds.getNorthEast().lat,
  //     bounds.getNorthEast().lng,
  //     level
  //   );
  // }

  /**
   * Find the most specific (highest precision geohash) that has 9 or less hashes
   */
  // findLevelWithLessThanNineHashs(bounds: LngLatBounds) {
  //   for (let level = 1; level <= 9; level++) {
  //     if (
  //       !this.geohashesByLevel[level] ||
  //       this.geohashesByLevel[level].length <= 0
  //     ) {
  //       this.geohashesByLevel[level] = this.getHashesInBounds(bounds, level);
  //     }
  //
  //     if (this.geohashesByLevel[level].length > 9) {
  //       if (level === 1) {
  //         return 1;
  //       }
  //       return level - 1;
  //     }
  //   }
  //
  //   return 9;
  // }

  onScrollPastImage(image: FeedImage, imageIndex: number) {
    if (this.feedImages.length < this.perPage) {
      return;
    }

    // If there are only 10 images past the current image, load a new one
    const distanceToEndOfFeed = this.feedImages.length - 1 - imageIndex;
    if (distanceToEndOfFeed < this.perPage) {
      this.currentPage++;
      this.loadImages();
    }
  }

  onFocusChanged(image: Image) {
    this.markerLocation = {
      lng: image.longitude,
      lat: image.latitude
    };
  }

  onMapBoundsChanged(bounds: LngLatBounds) {
    this.stagedMapBounds = bounds;
    if (this.firstMapLoad) {
      this.firstMapLoad = false;
      return;
    }
    this.isRedoSearchButtonVisible = true;
  }

  reloadList() {
    this.currentPage = 1;
    this.feedImages = [];
    this.mapBounds = this.stagedMapBounds;
    this.isRedoSearchButtonVisible = false;
    this.loadImages();
  }

  openImageUploader() {
    this.imageUploaderIsOpen = true;
  }

  closeImageUploader() {
    this.imageUploaderIsOpen = false;
  }

  // async loadPhotos() {
  //   const snapshot = await db.collection(PHOTOS_PATH)
  //   // .orderBy('likes')
  //   .where('geohash', '>', 'etgf0')
  //   .where('geohash', '<', 'etgfz')
  //   .limit(10)
  //   .get();
  //
  //   snapshot.docs.forEach(doc => {
  //     console.log('doc', doc.get('geohash'), doc.get('likes'));
  //   });
  //   // const geohashes = this.currentPhotoCountGeohashes;
  //   // photoCount * likes = score
  //
  //   // For each geohash (such as et), select all photos from 'et0 - etz' orderd by likes, limit X
  //
  //   // for(let i = 0; i < geohashes.length; i++) {
  //
  //   // }
  // }

  // loadPhotoCounts(geohashes: Array<string>) {
  //   this.currentPhotoCountGeohashes = [];
  //
  //   for(let i = 0; i < geohashes.length; i++) {
  //     const geohash = geohashes[i];
  //
  //     if(this.photoCountsByGeohash[geohash]) {
  //       this.currentPhotoCountGeohashes.push(geohash);
  //       continue;
  //     }
  //
  //     // We already searched for this doc, no need to hit our DB again
  //     if(this.photoCountsByGeohash[geohash] === null) {
  //       continue;
  //     }
  //
  //     this.fetchPhotoCounts(geohash);
  //   }
  // }

  // async fetchPhotoCounts(geohash: string){
  //   const snapshot = await db.collection(PHOTO_COUNT_PATH).where('id', '==', geohash).get();
  //   // console.log('docs', geohash, snapshot.size);
  //   if(snapshot.empty) {
  //     // set to null so we don't fetch this geohash again
  //     this.photoCountsByGeohash[geohash] = null;
  //     return;
  //   }
  //   this.currentPhotoCountGeohashes.push(geohash);
  //   this.photoCountsByGeohash[geohash] = snapshot.docs[0];
  // }
  @Debounce(1000)
  onSearch(val: string) {
    this.searchQuery = val;
    this.reloadList();
  }
}
